//////////////////////////////////////////////////////////////////////
// WEB COMPONENTS
//////////////////////////////////////////////////////////////////////

import { DocumentFrame } from "../apps/application/components/lazy-iframe";
customElements.define("document-frame", DocumentFrame);

import PDF from "../apps/application/components/pdf.svelte";
const target = document.getElementById("document-frame");

new PDF({
  target: target,
  props: {
    path: target.getAttribute("data-src"),
    pageCount: target.getAttribute("data-page-count"),
    customThumbnail: target.getAttribute("data-custom-thumbnail")
  }
});
